import React from 'react';
import { getPrimaryTier } from '../../DeviationViews/_helpers';
export var PrimaryTierContext = React.createContext({
    primaryTier: undefined,
});
PrimaryTierContext.displayName = 'PrimaryTierContext';
export var PrimaryTierContextProvider = function (_a) {
    var primaryTier = _a.primaryTier, children = _a.children;
    return (React.createElement(PrimaryTierContext.Provider, { value: { primaryTier: primaryTier } }, children));
};
PrimaryTierContextProvider.displayName = 'PrimaryTierContextProvider';
export function usePrimaryTier(deviation) {
    var contextualTier = React.useContext(PrimaryTierContext).primaryTier;
    return contextualTier || getPrimaryTier(deviation);
}
//# sourceMappingURL=PrimaryTierContext.js.map